import React, { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { FaDiscord, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  const isDark = theme === "dark";

  return (
    <footer className={`${isDark ? "bg-[#0f1114] text-white" : "bg-slate-50 text-gray-800 border-t border-gray-100"} w-full`}>
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="flex-1">
            <Link to="/" className="inline-flex items-center gap-3">
              <span className={`text-lg font-extrabold tracking-tight ${isDark ? "text-white" : "text-gray-800"}`}>
                KRAYNE <span className="text-rose-400">AGENCY</span>
              </span>
            </Link>
            <p className={`${isDark ? "text-gray-300" : "text-gray-600"} mt-4 max-w-md`}>Nous accompagnons les marques et les créateurs avec des solutions techniques, créatives et d'influence — hébergement sécurisé, design et stratégie TikTok.</p>
          </div>

          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div>
              <h4 className={`font-semibold mb-3 ${isDark ? "text-white" : "text-gray-800"}`}>Services</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/tech" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Pôle Tech</Link></li>
                <li><Link to="/creations" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Pôle Créatif</Link></li>
                <li><Link to="/influence" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Pôle Influence</Link></li>
              </ul>
            </div>

            <div>
              <h4 className={`font-semibold mb-3 ${isDark ? "text-white" : "text-gray-800"}`}>Aide</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/contact" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Contact</Link></li>
                <li><Link to="/privacy" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Politique de confidentialité</Link></li>
                <li><Link to="/terms" className={`hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Conditions</Link></li>
              </ul>
            </div>

              <div>
              <h4 className={`font-semibold mb-3 ${isDark ? "text-white" : "text-gray-800"}`}>Réseaux</h4>
              <div className="flex items-center gap-3 flex-wrap">
                <button className={`p-2 rounded-md flex items-center justify-center min-w-0 ${isDark ? "hover:bg-white/5" : "hover:bg-gray-100"} transition`} aria-label="Discord">
                  <FaDiscord className={`${isDark ? "text-white" : "text-gray-700"} text-lg sm:text-xl`} />
                </button>
                <button className={`p-2 rounded-md flex items-center justify-center min-w-0 ${isDark ? "hover:bg-white/5" : "hover:bg-gray-100"} transition`} aria-label="TikTok">
                  <FaTiktok className={`${isDark ? "text-white" : "text-gray-700"} text-lg sm:text-xl`} />
                </button>
                <button className={`p-2 rounded-md flex items-center justify-center min-w-0 ${isDark ? "hover:bg-white/5" : "hover:bg-gray-100"} transition`} aria-label="Instagram">
                  <FaInstagram className={`${isDark ? "text-white" : "text-gray-700"} text-lg sm:text-xl`} />
                </button>
                <button className={`p-2 rounded-md flex items-center justify-center min-w-0 ${isDark ? "hover:bg-white/5" : "hover:bg-gray-100"} transition`} aria-label="YouTube">
                  <FaYoutube className={`${isDark ? "text-rose-400" : "text-rose-600"} text-lg sm:text-xl`} />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t pt-6">
          <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-6">
            {/* Newsletter */}
            <div className="flex-1">
              <h4 className={`font-semibold mb-2 ${isDark ? "text-white" : "text-gray-800"}`}>Recevez nos actus</h4>
              <p className={`${isDark ? "text-gray-300" : "text-gray-600"} text-sm mb-3 max-w-md`}>Inscrivez-vous pour recevoir des conseils techniques, offres et cas client.</p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const email = e.target.elements.email?.value;
                  if (!email) return;
                  console.log("newsletter subscribe:", email);
                  e.target.reset();
                }}
                className="flex w-full max-w-md gap-2"
              >
                <input
                  name="email"
                  type="email"
                  placeholder="votre@email.com"
                  required
                  className={`flex-1 px-3 py-2 rounded-md outline-none border ${isDark ? "bg-[#0b0b0c] border-white/10 text-white" : "bg-white/95 border-gray-200 text-gray-800"}`}
                />
                <button type="submit" className={`px-4 py-2 rounded-md text-white ${isDark ? "bg-rose-500 hover:bg-rose-600" : "bg-rose-600 hover:bg-rose-700"} transition`}>S'inscrire</button>
              </form>
            </div>

            {/* Contact rapide + liens */}
            <div className="flex-1">
              <h4 className={`font-semibold mb-2 ${isDark ? "text-white" : "text-gray-800"}`}>Contact rapide</h4>
              <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-600"} mb-3`}>Email: <a href="mailto:contact@krayne.agency" className="hover:text-rose-400">contact@krayne.agency</a></div>
              <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-600"} mb-3`}>Tél: <a href="tel:+33123456789" className="hover:text-rose-400">+33 1 23 45 67 89</a></div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Link to="/legal" className={`text-sm hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Mentions légales</Link>
                <Link to="/privacy" className={`text-sm hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Politique de confidentialité</Link>
                <Link to="/contact" className={`text-sm hover:text-rose-400 transition ${isDark ? "text-gray-300" : "text-gray-600"}`}>Nous contacter</Link>
              </div>
            </div>
          </div>

          <div className="mt-6 flex items-center justify-between flex-col sm:flex-row gap-4">
            <p className={`${isDark ? "text-gray-400" : "text-gray-600"} text-sm`}>© 2025 Krayne Agency. Tous droits réservés.</p>
            <div className="flex items-center gap-4">
              <Link to="/sitemap" className={`text-sm hover:text-rose-400 transition ${isDark ? "text-gray-400" : "text-gray-600"}`}>Plan du site</Link>
              <Link to="/cookies" className={`text-sm hover:text-rose-400 transition ${isDark ? "text-gray-400" : "text-gray-600"}`}>Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
